"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  ListGroup: true
};
exports.default = exports.ListGroup = void 0;
var _bind = _interopRequireDefault(require("classnames/bind"));
var _react = _interopRequireWildcard(require("react"));
var _keycode = _interopRequireDefault(require("../keycode/keycode"));
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _Icon = require("../Icon/Icon");
var _useUniqueId = _interopRequireDefault(require("../utils/useUniqueId"));
var _ListContext = require("./_ListContext");
var _ListItem = require("./_ListItem");
var _listboxUtils = require("./_listboxUtils");
var _List = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./List.css") : void 0);
var _ListGroup = require("./_ListGroup.types");
Object.keys(_ListGroup).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _ListGroup[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ListGroup[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const CSS_BLOCK = 'sapcnqr-list';
const ListGroup = exports.ListGroup = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  var _a, _b;
  const {
      children,
      className,
      expandable,
      isRoot,
      heading,
      label,
      labelProps,
      listPrefixContent
    } = props,
    otherProps = __rest(props, ["children", "className", "expandable", "isRoot", "heading", "label", "labelProps", "listPrefixContent"]);
  const listContextValue = (0, _react.useContext)(_ListContext.ListContext);
  const adjustedLabel = heading || label;
  const {
    isUsingGroups,
    type,
    transparent
  } = listContextValue || {};
  const classnames = _bind.default.bind(_List.default);
  const [expanded, setExpanded] = (0, _react.useState)(typeof (expandable === null || expandable === void 0 ? void 0 : expandable.isExpanded) !== 'undefined' ? expandable === null || expandable === void 0 ? void 0 : expandable.isExpanded : true);
  const labelId = (0, _useUniqueId.default)();
  const ariaLabelledby = otherProps['aria-labelledby'];
  const generatedIDs = (0, _listboxUtils.getAriaLabelledBy)({
    ariaLabelledby,
    label: adjustedLabel,
    labelId
  });
  const onExpandButtonKeyDown = event => {
    var _a;
    if ((0, _keycode.default)(event) === 'space' || (0, _keycode.default)(event) === 'enter') {
      event.preventDefault();
      const isExpanded = !expanded;
      setExpanded(isExpanded);
      (_a = expandable === null || expandable === void 0 ? void 0 : expandable.onToggle) === null || _a === void 0 ? void 0 : _a.call(expandable, event, isExpanded);
    }
  };
  (0, _react.useEffect)(() => {
    if (typeof (expandable === null || expandable === void 0 ? void 0 : expandable.isExpanded) !== 'undefined') {
      setExpanded(!!(expandable === null || expandable === void 0 ? void 0 : expandable.isExpanded));
    }
  }, [expandable === null || expandable === void 0 ? void 0 : expandable.isExpanded]);
  const listItemProps = isRoot ? undefined : {
    isGroupHeader: isUsingGroups
  };
  const RootElement = isRoot ? _react.default.Fragment : _ListItem.ListItem;
  const classes = classnames(CSS_BLOCK, {
    [`${CSS_BLOCK}--collapsed`]: expandable && !expanded
  }, {
    [`${CSS_BLOCK}--expanded`]: expandable && expanded
  }, className);
  const labelClasses = classnames(`${CSS_BLOCK}__${heading ? 'heading' : 'label'}`, {
    [`${CSS_BLOCK}__${heading ? 'heading' : 'label'}--transparent`]: transparent
  }, labelProps === null || labelProps === void 0 ? void 0 : labelProps.className);
  const labelContent = adjustedLabel && (/*#__PURE__*/_react.default.createElement("div", Object.assign({}, labelProps, {
    id: labelId,
    className: labelClasses
  }), adjustedLabel));
  const passChildProps = child => {
    if (child.displayName === 'SkipLink') {
      return {
        inList: true
      };
    }
    return {};
  };
  return /*#__PURE__*/_react.default.createElement(RootElement, Object.assign({}, listItemProps), expandable ? (/*#__PURE__*/_react.default.createElement("div", Object.assign({}, expandable === null || expandable === void 0 ? void 0 : expandable.expandButtonProps, {
    "aria-describedby": generatedIDs,
    "aria-expanded": expanded,
    "aria-label": expanded ? (_a = expandable === null || expandable === void 0 ? void 0 : expandable.localizedText) === null || _a === void 0 ? void 0 : _a.textCollapse : (_b = expandable === null || expandable === void 0 ? void 0 : expandable.localizedText) === null || _b === void 0 ? void 0 : _b.textExpand,
    className: classnames(`${CSS_BLOCK}__expand-button`, {
      [`${CSS_BLOCK}__expand-button--collapsed`]: !expanded,
      [`${CSS_BLOCK}__expand-button--transparent`]: transparent
    }),
    onClick: e => {
      var _a;
      const isExpanded = !expanded;
      setExpanded(isExpanded);
      (_a = expandable === null || expandable === void 0 ? void 0 : expandable.onToggle) === null || _a === void 0 ? void 0 : _a.call(expandable, e, isExpanded);
    },
    onKeyDown: onExpandButtonKeyDown,
    role: "button",
    tabIndex: 0
  }), /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    ariaHidden: true,
    className: classnames(`${CSS_BLOCK}__expand-icon`),
    iconName: expanded ? 'slim-arrow-up' : 'slim-arrow-down'
  }), labelContent)) : labelContent, /*#__PURE__*/_react.default.createElement(_AddChildPropsContext.AddChildPropsProvider, {
    value: passChildProps
  }, listPrefixContent), type === 'ordered' ? (/*#__PURE__*/_react.default.createElement("ol", Object.assign({}, otherProps, {
    "aria-labelledby": generatedIDs,
    className: classes,
    ref: ref
  }), children)) : (/*#__PURE__*/_react.default.createElement("ul", Object.assign({}, otherProps, {
    "aria-labelledby": generatedIDs,
    className: classes,
    ref: ref
  }), children)));
});
ListGroup.displayName = 'List.Group';
var _default = exports.default = ListGroup;